const JERRY_DEVICE_TYPES = ['jerry', 'jerry-lora', 'jerry-bait-rat']

export const getSelectedOperationModes = ({
    operation_modes,
    device_types
}) => {
    let res = []
    if (
        device_types.some(deviceType => JERRY_DEVICE_TYPES.includes(deviceType))
    ) {
        operation_modes.forEach(el => {
            res.push(`jerry:${el}`)
        })
    }
    if (device_types.includes('tom')) {
        operation_modes.forEach(el => {
            res.push(`tom:${el}`)
        })
    }
    return res
}
